import { Router } from '@angular/router';
import { AuthService } from '@zaoblako/web/core/services/security/auth.service';
import { flatten } from 'flat';

/**
 * Opens an entity card respecting the user's "open cards in new tab" profile setting.
 * Use only for navigation to entity cards (user, deal, task, etc.).
 */
export function navigateToCard(
  router: Router,
  authService: AuthService,
  commands: string | any[],
  queryParams?: Record<string, unknown> | null
): void {
  const linkCommands = typeof commands === 'string' ? [commands] : commands;
  if (!linkCommands?.length) {
    return;
  }

  const flatQueryParams = queryParams ? flatten(queryParams) : queryParams;

  if (authService.currentProfile?.cardOnNewTab) {
    const url = router.serializeUrl(
      router.createUrlTree(linkCommands, {
        queryParams: flatQueryParams ?? undefined
      })
    );
    window.open(url, '_blank');
    return;
  }

  router
    .navigate(linkCommands, {
      queryParams: flatQueryParams ?? undefined
    })
    .catch(console.error);
}

/**
 * Opens a report drill-down URL in a new tab. Not tied to cardOnNewTab — drill-down
 * from subtotal/registry numeric cells always opens the target report in a new tab.
 */
export function openReportDrillUrl(url: string): void {
  if (!url) {
    return;
  }
  window.open(url, '_blank');
}
